<style scoped lang="sass">
.page
  background-color: white !important
  .padded
    background: linear-gradient(to bottom, var(--light-gray), var(--light-gray) 150px, white 100px)
</style>
<template>
  <div class="page">
    <div class="padded">
      <div v-if="genericErrors.length">
        <div v-for="error in genericErrors">{{error}}</div>
      </div>
      <transition :name="transition">
        <component :is="step" :go-to-step="goToStep"></component>
      </transition>
    </div>
  </div>
</template>
<script>
import Vuex from 'vuex';

import Setup from './pool-form/setup.vue';
import Configure from './pool-form/configure.vue';
import Invite from './pool-form/invite.vue';
import api from '../api';

export default {
  name: 'PoolForm',
  components: {
    Setup,
    Configure,
    Invite
  },
  data() {
    return {
      transition: 'slide-forward',
      step: 'setup',
      genericErrors: []
    };
  },
  async created() {
    // If editing
    if (this.$route.params.id) {
      // If pool in cache, use it
      if (this.$store.getters['getCachedPool'](this.$route.params.id)) {
        await this.$store.dispatch('poolForm/setPool', this.$store.getters['getCachedPool'](this.$route.params.id));
        await this.$store.dispatch('configNavigation', {leftEnabled: true, leftRoute: {name: 'pool', id: this.$route.params.id}, leftImg: 'icon-back.svg'});
      // Otherwise how did the user get here? Redirect to pool page
      } else {
        this.$router.replace({name: 'pool', id: this.$route.params.id});
      }
    } else {
      this.$store.dispatch('configNavigation', {leftEnabled: true, leftRoute: {name: 'dashboard'}, leftImg: 'icon-back.svg'});
      const recentOwnedPools = await api.OwnedPool.index({params: {limit: 1, offset: 0}});
      if (recentOwnedPools[0]) {
        await this.$store.dispatch('poolForm/setPoolTemplate', recentOwnedPools[0]);
      }
    }
  },
  destroyed() {
    this.$store.dispatch('poolForm/resetPool');
  },
  computed: {
    ...Vuex.mapGetters('poolForm', ['pool', 'isPoolNew']),
  },
  methods: {
    goToStep({step}) {
      if (step === null) {
        if (this.isPoolNew) {
          api.Pool.create({params: {pool: this.pool}}).then(pool => {
            this.$store.commit('updateCachedPool', pool);
            this.$router.replace({name: 'pool', params: {id: pool.id}});
          }).catch(err => {
            this.genericErrors = err.response.data.errors;
            this.step = 'setup';
          });
        } else {
          api.Pool.update({params: {pool: this.pool}}).then(pool => {
            this.$store.commit('updateCachedPool', pool);
            this.$router.replace({name: 'pool', params: {id: this.pool.id}});
          }).catch(err => {
            this.genericErrors = err.response.data.errors;
            this.step = 'setup';
          });
        }
      } else {
        this.step = step;
      }
    }
  }
};
</script>
